import { Link } from "react-router-dom";
import { YOUTUBE_URL } from "../lib/brand";

export default function Footer() {
  return (
    <footer className="border-t-4 border-black bg-[#0A0A0A] text-white mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid grid-cols-1 sm:grid-cols-3 gap-8">
        <div>
          <p className="font-display text-2xl text-[#FFD500] mb-2">
            ANTHONY&apos;S PLAYWORLD
          </p>
          <p className="text-sm opacity-80">
            Official merch store of the Playworld YouTube adventure.
          </p>
        </div>
        <div>
          <p className="font-bold uppercase tracking-wider mb-3 text-[#00E5FF]">Shop</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:underline">All Merch</Link></li>
            <li><Link to="/shop?category=T-Shirts" className="hover:underline">T-Shirts</Link></li>
            <li><Link to="/shop?category=Hoodies" className="hover:underline">Hoodies</Link></li>
            <li><Link to="/shop?category=Toys%20%26%20Plushies" className="hover:underline">Toys & Plushies</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-bold uppercase tracking-wider mb-3 text-[#FF2E93]">Channel</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:underline">About</Link></li>
            <li>
              <a href={YOUTUBE_URL} target="_blank" rel="noopener noreferrer" className="hover:underline">
                YouTube
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t-2 border-white/20 text-center text-xs opacity-70 py-4">
        © {new Date().getFullYear()} Anthony&apos;s Playworld. All rights reserved.
      </div>
    </footer>
  );
}
